__turbopack_context__.v({
  "list": "ReorderRoles-module__hqkq1a__list",
  "name": "ReorderRoles-module__hqkq1a__name",
  "position": "ReorderRoles-module__hqkq1a__position",
  "row": "ReorderRoles-module__hqkq1a__row",
  "text": "ReorderRoles-module__hqkq1a__text",
});
